import React from "react";
import {
  Datagrid,
  Filter,
  TextField,
  FunctionField,
  ListProps,
  DateInput,
  ReferenceField,
  SearchInput,
} from "react-admin";
import ListWrapper from "../../components/ListWrapper";
import ListShowButton from "../../components/ListShowButton";
import ActionsMenu from "../../components/ActionsMenu";
import CustomDateField from "../../components/CustomDateField";
import ListEditButton from "../../components/ListEditButton";
import { SchoolIdSelected } from "../../utils/tools";
import moment from "moment";
import BulkDeleteAdhocOperatorButton from "./components/BulkDeleteAdhocOperatorButton";

const AdhocOperatorFilter = (props: any) => (
  <Filter {...props}>
    <SearchInput source="search" alwaysOn />
    <DateInput source="Date" label="Date" alwaysOn />
  </Filter>
);

const AdhocOperatorList = (props: ListProps) => {
  const breadcrumb = [{ link: "/adhocOperators", title: "Adhoc Operators" }];

  return (
    <>
      <ListWrapper
        breadcrumb={breadcrumb}
        headerTitle="Adhoc Operators"
        denseMode
        {...props}
        exporter={false}
        filters={<AdhocOperatorFilter />}
        filter={{
          SchoolId: Number(SchoolIdSelected()),
        }}
        sort={{
          field: "date",
          order: "DESC",
        }}
        bulkActionButtons={<BulkDeleteAdhocOperatorButton />}
      >
        <Datagrid>
          <TextField source="id" emptyText="-" />
          <ReferenceField
            label="Route Plan Wave"
            source="busSchedulePlanId"
            reference="busSchedulePlans"
            link={false}
          >
            <ReferenceField
              source="busScheduleId"
              reference="busSchedules"
              link={false}
            >
              <TextField source="name" />
            </ReferenceField>
          </ReferenceField>
          <ReferenceField
            label="Route"
            source="routeId"
            reference="routes"
            link={false}
          >
            <TextField source="name" />
          </ReferenceField>
          <CustomDateField
            source="date"
            label="Replacement Date"
            emptyText="-"
          />
          <ReferenceField
            source="driverId"
            label="Driver"
            reference="drivers"
            emptyText="-"
            link="show"
          >
            <TextField source="fullName" />
          </ReferenceField>
          <ReferenceField
            source="busAssistantId"
            label="Bus Assistant"
            reference="busAssistants"
            emptyText="-"
            link="show"
          >
            <TextField source="fullName" />
          </ReferenceField>
          <ReferenceField
            source="subcontractorId"
            label="Subcontractor"
            reference="subcontractors"
            emptyText="-"
            link="show"
          >
            <TextField source="name" />
          </ReferenceField>
          <FunctionField
            label="Actions"
            render={(record: any) => (
              <ActionsMenu
                render={[
                  <ListShowButton record={record} />,
                  moment(record.date).isAfter(moment(), "day") && (
                    <ListEditButton record={record} />
                  ),
                ]}
              />
            )}
          />
        </Datagrid>
      </ListWrapper>
    </>
  );
};

export default AdhocOperatorList;
